"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTION_FLOW_MAPPING = {
    prefix: 'collection-flows',
    createCollectionFlow: {
        path: '/createCollectionFlow',
        parameter: '/:facilityId'
    },
    createCollectionFlows: {
        path: '/createCollectionFlows'
    },
    updateCollectionFlow: {
        path: '/updateCollectionFlow',
        parameter: '/:collectionFlowId'
    },
    getFacilityCollectionFlows: {
        path: '/getFacilityCollectionFlows',
        parameter: '/:facilityId'
    },
    getAllCollectionFlows: {
        path: '/getAllCollectionFlows'
    },
    getCollectionFlowById: {
        path: '/getCollectionFlowById',
        parameter: '/:collectionFlowId'
    },
    deleteCollectionFlow: {
        path: '/deleteCollectionFlow',
        parameter: '/:collectionFlowId'
    },
    getCollectionTasks: {
        path: '/getCollectionTasks'
    },
    scheduleCallWithResident: {
        path: '/scheduleCallWithResident',
        parameter: '/:residentId'
    },
    residentCalled: {
        path: '/residentCalled',
        parameter: '/:residentId'
    },
    sendMailToResidentContact: {
        path: '/sendMailToResidentContact',
        parameter: '/:residentId'
    },
    changeEscalation: {
        path: '/changeEscalation',
        parameter: '/:residentId'
    },
    changeCollectionTaskAssignedUser: {
        path: '/changeCollectionTaskAssignedUser',
        parameter: '/:collectionTaskId'
    },
    addHistoryNote: {
        path: '/addHistoryNote',
        parameter: '/:residentId'
    }
};
